// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___72366c8481fe9aa1e5c","cls2":"Comments-cls2___1f96f71214943147928 Comments-cls1___72366c8481fe9aa1e5c"};